import { format } from 'date-fns';

export function createPrefixMessage(name: string) {
  return (message: string): string => prefixMessage(name, message);
}

function prefixMessage(name: string, message: string): string {
  const timestamp = format(new Date(), 'HH:mm:ss');

  return `\x1b[31m[${name} ${timestamp}] ${message}\x1b[0m`;
}
